import { TripTypeEnum } from '../../types/enums/trip/trip-type.enum'
import { TripFilters } from '../../types/models/trip/trip'

export const transformTripFiltersToUrl = (filters?: TripFilters): string => {
  if (!filters) return ''
  const searchParams = new URLSearchParams()

  if (filters.type !== undefined) searchParams.append('type', filters.type.toString())
  if (filters.countryCodes && filters.countryCodes.length)
    searchParams.append('countryCodes', filters.countryCodes.join(','))

  if (filters.arrivals && filters.arrivals.length)
    searchParams.append('arrivals', filters.arrivals.join(','))

  if (filters.departures && filters.departures.length)
    searchParams.append('departures', filters.departures.join(','))

  if (filters.periods && filters.periods.length)
    searchParams.append('periods', filters.periods.join(','))

  if (filters.transportMeans && filters.transportMeans.length)
    searchParams.append('transportMeans', filters.transportMeans.join(','))

  return searchParams.toString()
}

export const transformUrlToTripFilters = (searchParams: URLSearchParams): TripFilters => {
  const filters: TripFilters = {}

  const type = searchParams.get('type')
  if (type) filters.type = type as TripTypeEnum
  const countryCodes = searchParams.get('countryCodes')
  if (countryCodes && countryCodes.length) filters.countryCodes = countryCodes.split(',')
  const arrivals = searchParams.get('arrivals')
  if (arrivals && arrivals.length) filters.arrivals = arrivals.split(',')
  const departures = searchParams.get('departures')
  if (departures && departures.length) filters.departures = departures.split(',')
  const periods = searchParams.get('periods')
  if (periods && periods.length) filters.periods = periods.split(',')
  const transportMeans = searchParams.get('transportMeans')
  if (transportMeans && transportMeans.length) filters.transportMeans = transportMeans.split(',')

  return filters
}
